import Vue from 'vue'
import router from '@/router'
import * as Sentry from '@sentry/vue'
import i18n from './i18n'

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,

  environment: process.env.VUE_APP_STAGE,
  release: process.env.VUE_APP_GIT_SHA,

  // // Setting this option to true will send default PII data to Sentry.
  // // For example, automatic IP address collection on events
  // sendDefaultPii: true,

  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
    Sentry.feedbackIntegration({
      isNameRequired: true,
      isEmailRequired: true,

      // text customization
      triggerLabel: i18n.t('sentry.feedback.triggerLabel'),
      triggerAriaLabel: i18n.t('sentry.feedback.triggerAriaLabel'),
      formTitle: i18n.t('sentry.feedback.formTitle'),
      submitButtonLabel: i18n.t('sentry.feedback.submitButtonLabel'),
      cancelButtonLabel: i18n.t('sentry.feedback.cancelButtonLabel'),
      confirmButtonLabel: i18n.t('sentry.feedback.confirmButtonLabel'),
      addScreenshotButtonLabel: i18n.t(
        'sentry.feedback.addScreenshotButtonLabel'
      ),
      removeScreenshotButtonLabel: i18n.t(
        'sentry.feedback.removeScreenshotButtonLabel'
      ),
      nameLabel: i18n.t('sentry.feedback.nameLabel'),
      namePlaceholder: i18n.t('sentry.feedback.namePlaceholder'),
      emailLabel: i18n.t('sentry.feedback.emailLabel'),
      emailPlaceholder: i18n.t('sentry.feedback.emailPlaceholder'),
      isRequiredLabel: i18n.t('sentry.feedback.isRequiredLabel'),
      messageLabel: i18n.t('sentry.feedback.messageLabel'),
      messagePlaceholder: i18n.t('sentry.feedback.messagePlaceholder'),
      successMessageText: i18n.t('sentry.feedback.successMessageText'),
      highlightToolText: i18n.t('sentry.feedback.highlightToolText'),
      hideToolText: i18n.t('sentry.feedback.hideToolText'),
      removeHighlightText: i18n.t('sentry.feedback.removeHighlightText')
    })
  ],

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: [process.env.VUE_APP_API_URL],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  // replaysSessionSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
})
